import axios from 'axios';
import { ResponseSuccessModel } from '../../models/system/responseSuccessModel';
import { API_URL } from '../../config/system/systemConfig';
import { ContactSubmissionModel } from '../../models/platform/contactSubmissionModel';
import { AccountModel } from '../../models/platform/accountModel';
import authHeader from '../../utils/authHeaderUtils';
import { handleAxiosError } from '../../utils/errorUtils';


class ContactApi {

    async sendSupportRequest(contact: ContactSubmissionModel) {
        try {
            const response = await axios.post(`${API_URL}/api/contact/support`, contact,
                {
                    headers: authHeader(),
                });

            return response.data;
        } catch (error) {
            return handleAxiosError(error);
        }
    }
}

const contactApi = new ContactApi();
export default contactApi;

